export enum AppInputColorEnum {
    DEFAULT = 'default',
    LOGIN = 'login',
}
